import { Col, Row } from "antd";
import { EditorMenu } from "../components/editor/editor-menu";
import { useSearchParams } from "../../../hook/use-search-params";
import { CommentList } from "../comment/comment-list";
import EditorViewDecentralize from "../components/editor/editor-in-process/editor-view-decentralize";
import { EditorContentInProcess } from "../components/editor/editor-in-process/editor-content-in-process";

export const DetailDocumentViewEditor = () => {
  const { searchParams } = useSearchParams();
  const isShowComment = searchParams.get("step") === "feedback";
  const mode = searchParams.get("mode");
  const isDecentralize = mode === "decentralize";

  const renderDocumentContent = () => {
    if (!isDecentralize) {
      return (
        <Row className="border rounded-lg">
          <Col xs={4} sm={4} md={4} className={"preview"}>
            <div className="document-editor__menu">
              <div className="d-flex align-items-center justify-content-center">
                <EditorMenu />
              </div>
            </div>
          </Col>
          <Col xs={20} sm={20} md={20}>
            <div className={"document-editor__content"}>
              <EditorContentInProcess />
            </div>
          </Col>
        </Row>
      );
    } else return <EditorViewDecentralize />;
  };
  return isShowComment ? (
    <Row>
      <Col>
        <CommentList />
      </Col>
    </Row>
  ) : (
    renderDocumentContent()
  );
};
